{
  "branding": {
    "frontdesk-attribution": "A FrontDesk+ támogatásával",
    "practice-logo": "{{name}} logója"
  },
  "validation": {
    "required": "Ez a mező kötelező",
    "invalid-url": "Kérjük, adjon meg egy érvényes URL címet",
    "pin-too-short": "A PIN-nek legalább 4 karakterből kell állnia",
    "pin-default-rejected": "A szabványos PIN 0000 nem engedélyezett. Kérjük, adja meg saját PIN-kódját.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Vissza",
    "next": "Következő",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "done": "Kész",
    "retry": "Újra",
    "clear": "Törlés",
    "close": "Bezárás",
    "verifying": "Ellenőrzés...",
    "select": "Kiválasztás",
    "minutes": "perc",
    "clock": "",
    "gender": {
      "M": "Férfi",
      "W": "Nő",
      "D": "Egyéb",
      "U": "Ismeretlen"
    },
    "insurance": {
      "GKV": "Kötelező",
      "PKV": "Magán",
      "SELFPAY": "Önfizetés"
    },
    "scroll-up": "Görgetés felfelé",
    "scroll-down": "Görgetés lefelé"
  },
  "settings": {
    "device-reset": {
      "title": "Eszköz alaphelyzetbe állítása",
      "description": "A rendelőkapcsolat, az eszközbeállítások és a PIN-kód törlése erről az eszközről.",
      "confirmation": "Az eszközt újra be kell állítani. A SOL konfigurációja és az inSuite betegadatai változatlanok maradnak.",
      "cancel": "Mégse",
      "confirm": "Alaphelyzetbe állítás"
    },
    "title": "Beállítások",
    "save": "Mentés",
    "save-success": "Beállítások mentve",
    "save-error": "Hiba a beállítások mentésekor",
    "load-error": "Hiba a beállítások betöltésekor",
    "pin": {
      "title": "PIN szükséges",
      "description": "Kérjük, adja meg PIN-jét a beállításokhoz való hozzáféréshez.",
      "error": "Hibás PIN. Kérjük, próbálja újra.",
      "backspace": "Utolsó számjegy törlése"
    },
    "connection": {
      "title": "Kapcsolat",
      "description": "Kapcsolati beállítások a Doc-Cirrus Bridge szerverhez",
      "bridge-url": "Bridge URL",
      "device-name": "Eszköz neve",
      "device-name-placeholder": "pl. Recepció, 1. szoba, Kioszk",
      "device-name-hint": "Név az azonosításhoz az Bridge műszerfalon",
      "kim-address": "KIM cím (opcionális)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Teszt",
      "success": "Sikeres kapcsolat",
      "error": "Sikertelen kapcsolat",
      "api-unreachable": "DocCirrus API nem érhető el",
      "status-title": "Kapcsolat állapota",
      "status": {
        "api": "API csatlakoztatva",
        "ti": "Telematikai infrastruktúra",
        "card-reader": "Kártyaolvasó elérhető",
        "medical-card": "Orvosi rendelő kártya (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (az inSuite-ból)",
      "sol-token-hint": "Másolja ki az inSuite Bridge-kezeléséből. A kapcsolathoz szükséges.",
      "sol-token-show": "Token megjelenítése",
      "sol-token-hide": "Token elrejtése",
      "bridge-unreachable": "A Bridge nem érhető el. Ellenőrizze a címet és a portot.",
      "diagnostic-id": "Diagnosztikai azonosító: {{id}}",
      "scan-qr": "QR-kód beolvasása",
      "scan-title": "Bridge QR-kód beolvasása",
      "scan-manual": "Kézi megadás"
    },
    "terminal": {
      "title": "Kártyaolvasó",
      "description": "Kártyaolvasó kiválasztása a telematikai infrastruktúrához",
      "select": "Terminál kiválasztása",
      "select-placeholder": "Válasszon terminált...",
      "loading": "Terminálok betöltése...",
      "none-available": "Nincs elérhető terminál",
      "none-found": "Nem található terminál",
      "found": "{{count}} terminál találva",
      "connect-hint": "Először csatlakozzon a bridge szerverhez a terminálok betöltéséhez.",
      "found-count": "Talált kártyaolvasók: {{count}}",
      "refresh": "Kártyaolvasók újratöltése"
    },
    "practice": {
      "title": "Orvosi rendelő",
      "description": "Információk az orvosi rendelőjéről",
      "name": "Orvosi rendelő neve",
      "name-placeholder": "pl. Dr. Nagy",
      "welcome-message": "Üdvözlő üzenet",
      "welcome-placeholder": "pl. Üdvözöljük rendelőnkben",
      "scheduler-available": "Ütemező engedélyezése",
      "scheduler-available-description": "Lehetővé teszi a betegek számára, hogy időpontot foglaljanak az önkiszolgáló terminálon keresztül",
      "prescription-available": "Vényköteles szolgáltatás engedélyezése",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Hagyja üresen, hogy az üdvözlés a beteg nyelvén jelenjen meg. A saját szöveg minden nyelven változatlanul jelenik meg."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Minden eszközre mentve: {{value}}",
      "never-saved-default": "Alapértelmezett beállítás, még nem módosították."
    },
    "anamnesis": {
      "title": "Digitális Orvostörténet",
      "description": "A bejelentkezés után egy hivatkozást és QR code-et jelenít meg a kórtörténet-szolgáltatóhoz.",
      "enabled": "Bejelentkezés után mutasd meg a kórtörténeti linket",
      "enabled-description": "Egy linket és QR code-et jelenít meg a kórelőzmény-szolgáltatóhoz a bejelentkezés befejezése után, például Nelly.",
      "url": "Orvostörténeti szolgáltató link",
      "url-hint": "A kapcsolat statikus és minden beteg számára azonos.",
      "preview-label": "Befejezési képernyő előnézete",
      "preview-note": "A kapcsolat statikus és minden beteg számára azonos.",
      "url-first": "A bekapcsoláshoz először adjon meg egy érvényes linket."
    },
    "appearance": {
      "title": "Megjelenés",
      "description": "A felhasználói felület testreszabása",
      "language": "Nyelv",
      "default-kiosk-language": "Alapértelmezett betegnyelv",
      "default-kiosk-language-hint": "Nyelv, amelyen új kioszk-munkamenetek indulnak a betegek számára.",
      "voice-over-volume": "Voice-Over hangerő",
      "voice-over-hint": "Szabályozza a hangosító asszisztens hangerejét a hozzáférhetőség érdekében.",
      "language-first": "Nyelvválasztás megjelenítése a munkamenet elején"
    },
    "security": {
      "title": "Biztonság",
      "description": "PIN a beállításokhoz való hozzáféréshez",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Kioszkkezelés",
    "nav": {
      "general": "Általános",
      "flows": "Funkciók",
      "anamnese": "Digitális anamnézis",
      "device": "Eszköz és kapcsolat"
    },
    "flows": {
      "title": "Funkciók a terminálon"
    },
    "language": {
      "title": "Nyelv és felolvasás",
      "description": "Nyelv és felolvasás a betegek számára ezen az eszközön."
    }
  },
  "self-service": {
    "title": "Önkiszolgálás",
    "step-progress": "{{current}} / {{total}} lépés",
    "flows": {
      "checkin": "Bejelentkezés",
      "scheduler": "Időpont foglalás",
      "prescription": "Előírások",
      "locations": "Helyszín térkép",
      "emergency": "Sürgősség"
    },
    "audio-guide": {
      "on": "Hang bekapcsolva",
      "off": "Hang kikapcsolva",
      "replay": "Útmutató újrajátszása",
      "replay-unavailable": "Nincs újrajátszható hangos útmutató"
    },
    "language-selector": {
      "title": "Válasszon nyelvet",
      "description": "Kérjük, válassza ki a kívánt nyelvet"
    },
    "settings": "Beállítások",
    "start": {
      "welcome": "Üdvözöljük",
      "subtitle": "Kérjük, válasszon egy lehetőséget",
      "check-in-label": "Fő út",
      "check-in-cta": "Bejelentkezés",
      "check-in-description": "Már van időpontja? Jelentkezzen be itt.",
      "check-in-hint": "Készítse elő a kártyáját",
      "scheduler-label": "Új",
      "scheduler-cta": "Időpont foglalás",
      "scheduler-description": "Foglaljon új időpontot.",
      "location-plan": "Helyszín térkép",
      "location-plan-description": "Találja meg az utat a kezelőszobához.",
      "prescription-label": "Vényköteles",
      "prescription-cta": "Receptek és rendelés",
      "prescription-description": "Tekintse meg a recepteket vagy rendeljen utántöltőt.",
      "emergency-cta": "Helyi vészjelzés",
      "emergency-description": "Csak ezen az eszközön hallható, és nem hív segítséget.",
      "tap-to-start": "Koppintson az indításhoz"
    },
    "offline": {
      "banner-title": "A bejelentkezés átmenetileg nem elérhető",
      "banner-message": "Kérjük, forduljon a recepció személyzetéhez segítségért.",
      "emergency-available": "A helyi jelzés továbbra is elérhető. Nem hív segítséget.",
      "flow-disabled": "Átmenetileg nem elérhető"
    },
    "readability": {
      "toggle-label": "Olvasási mód",
      "on": "Olvasási mód",
      "off": "Olvasási mód"
    },
    "reset-overlay": {
      "timeout-title": "Az ülés véget ért",
      "timeout-subtitle": "Az Ön ideje lejárt. Adatai biztonságban vannak.",
      "offline-title": "Megszakadt a kapcsolat",
      "offline-subtitle": "A kapcsolat megszakadt. Kérjük, beszéljen a recepció személyzetével.",
      "interruption-title": "Az ülés véget ért",
      "interruption-subtitle": "A munkamenet biztonságosan befejeződött.",
      "completion-title": "Köszönöm!",
      "completion-subtitle": "Kérése sikeresen teljesítve.",
      "reassurance": "Az Ön személyes adatait nem tároljuk ezen az eszközön.",
      "auto-dismiss": "{{seconds}} másodperc múlva visszatér a kezdéshez...",
      "dismiss": "Menjen a kezdéshez"
    },
    "timed-terminal": {
      "countdown": "Automatikus visszatérés {{seconds}} másodpercben",
      "countdown-outcome": "Ez a terminál automatikusan visszatér a kezdőképernyőre.",
      "more-time": "Több idő",
      "extended": "Idő meghosszabbítva"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Ezek a kérdések nem érhetők el az Ön nyelvén. Válasszon a felkínált nyelvek közül, vagy forduljon a recepcióhoz.",
        "alternatives": "Alternatív időpontok",
        "loading": "Kérdések betöltése…",
        "reception-fallback": "Kérjük, forduljon a recepcióhoz.",
        "error-title": "A kérdéseket nem sikerült betölteni",
        "language-unavailable-lead": "Ezek a kérdések az Ön nyelvén nem érhetők el.",
        "language-unavailable-title": "Kérjük, válasszon egyet ezek közül a nyelvek közül",
        "language-unavailable-body": "Vagy kérjen segítséget a recepción."
      },
      "start": {
        "title": "Időpont foglalás",
        "subtitle": "Foglalja le kívánt időpontját néhány lépésben",
        "welcome": "Üdvözöljük az időpontfoglalásban",
        "description": "Végigvezetjük a foglalási folyamaton",
        "cta": "Időpont foglalása most"
      },
      "patient-id": {
        "title": "Azonosítás",
        "subtitle": "Kérjük, azonosítsa magát",
        "mode-card": "Kártyával",
        "mode-search": "Keresés",
        "mode-create": "Új létrehozása",
        "insert-card": "Kérjük, helyezze be egészségbiztosítási kártyáját",
        "reading-card": "Kártya olvasása...",
        "simulate-card": "Kártya szimulálása",
        "multiple-matches": "Több páciens található. A kártya adatai kerülnek felhasználásra.",
        "search-placeholder": "Név vagy biztosítási szám...",
        "searching": "Keresés...",
        "no-results": "Nincs találat",
        "first-name": "Keresztnév",
        "last-name": "Vezetéknév",
        "dob": "Születési dátum",
        "insurance": "Biztosítás",
        "continue": "Folytatás",
        "creating": "Beteg létrehozása...",
        "patient-created": "A páciens sikeresen létrehozva!",
        "create-error": "Nem sikerült létrehozni a pácienst."
      },
      "appointment-type": {
        "title": "Válassza ki az időpont típusát",
        "subtitle": "Kérjük, válassza ki látogatása okát",
        "loading": "Időpont típusok betöltése...",
        "no-types": "Nincs elérhető időpont típus",
        "error": "Nem sikerült betölteni az időpont típusokat. Kérjük, próbálja újra.",
        "no-bookable": "Ezek az időponttípusok jelenleg nem foglalhatók a kioszkon. Kérjük, forduljon a recepcióhoz, vagy foglaljon telefonon.",
        "disabled-default": "Kérjük, ezt az időpontot közvetlenül a recepción vagy telefonon egyeztesse.",
        "disabled-footer": "Csak recepció/telefon",
        "lead": "Milyen időpontot szeretne foglalni?",
        "duration": "kb. {{minutes}} perc",
        "empty-title": "Itt jelenleg nem lehet időpontot foglalni",
        "none-bookable-title": "Ezeket az időpontokat itt nem lehet lefoglalni",
        "none-bookable-body": "Kérjük, kérdezzen a recepción, vagy hívjon minket."
      },
      "types": {
        "general": "Általános konzultáció",
        "general-desc": "Általános panaszokhoz és kérdésekhez",
        "checkup": "Megelőző vizsgálat",
        "checkup-desc": "Rendszeres egészségügyi vizsgálatok",
        "vaccination": "Oltás",
        "vaccination-desc": "Oltás időpontjának foglalása",
        "followup": "Kontroll",
        "followup-desc": "Kontroll időpont",
        "prescription": "Recept",
        "prescription-desc": "Recept átvétele"
      },
      "slot-selection": {
        "title": "Válasszon időpontot",
        "subtitle": "Kérjük, válasszon egy elérhető időpontot",
        "loading": "Elérhető időpontok betöltése...",
        "no-slots": "Nincs elérhető időpont",
        "no-appointment-type": "Nincs kiválasztva időpont típus",
        "error": "Nem sikerült betölteni az elérhető időpontokat. Kérjük, próbálja újra.",
        "quick-select": "Következő elérhető időpontok:",
        "select-date": "Vagy válasszon dátumot:",
        "times-for": "{{date}}",
        "available": "Elérhető",
        "unavailable": "Nincs időpont",
        "slots": "időpontok",
        "select-time-hint": "Érintsen meg egy időpontot a foglaláshoz",
        "week-short": "Hét",
        "weekday-mon": "Hé",
        "weekday-tue": "Ke",
        "weekday-wed": "Sze",
        "weekday-thu": "Csü",
        "weekday-fri": "Pé",
        "weekday-sat": "Szo",
        "weekday-sun": "Vas",
        "period-morning": "Reggel",
        "period-midday": "Dél",
        "period-afternoon": "Délután",
        "period-evening": "Este",
        "period-morning-short": "Reg.",
        "period-midday-short": "Dél",
        "period-afternoon-short": "Dél.",
        "period-evening-short": "Este",
        "period-dots-legend": "Időpont elérhetőség",
        "filter-hint": "Szűrés preferált időpontok szerint:",
        "or-choose-below": "vagy válasszon lentebb",
        "no-slots-period": "Nincsenek helyek",
        "show-all": "Összes megjelenítése",
        "free": "ingyenes",
        "your-selection": "Az Ön választása",
        "oclock": "óra",
        "choose-slot": "Válassz nyílást",
        "choose-day": "Nap kiválasztása",
        "choose-day-first": "Kérjük, először válasszon napot",
        "times-heading": "Szabad időpontok: {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Nincs szabad időpont: {{month}}",
        "empty-body": "Nézze meg a következő hónapot, vagy kérdezzen a recepción – szívesen segítünk.",
        "next-month": "Következő hónap",
        "previous-month": "Előző hónap"
      },
      "confirmation": {
        "patient-responses": "Az Ön válaszai",
        "review-loading": "Az összefoglaló ellenőrzése…",
        "review-unavailable": "Az összefoglaló nem érhető el. Kérjük, próbálja újra, vagy kérdezzen a recepción.",
        "check-booking": "Foglalás ellenőrzése",
        "title": "Időpont megerősítése",
        "subtitle": "Kérjük, ellenőrizze foglalását",
        "patient": "Páciens",
        "datetime": "Dátum és idő",
        "booking": "Foglalás...",
        "confirm": "Időpont foglalása",
        "heading": "Ez jól néz ki?",
        "lead": "Kérjük, erősítse meg időpontját.",
        "appointment": "Kinevezés",
        "insured-via": "keresztül biztosított",
        "description-label": "Megjegyzések a rendelőnek (opcionális)",
        "description-hint": "Jelezze, ha az időpontfoglalásnál vagy bejelentkezésnél valamire figyelnünk kell.",
        "description-placeholder": "pl. korlátozott mozgásképesség, kísérő, fontos megjegyzések",
        "description-too-long": "Kérjük, rövidítse a megjegyzést legfeljebb 500 karakterre.",
        "summary": "Összegzés",
        "change": "Változás",
        "book-binding": "Foglaljon időpontot",
        "cancel": "Mégse",
        "type-label": "Időpont típusa",
        "datetime-value": "{{date}}, {{time}}",
        "name-label": "Név",
        "insurance-label": "Biztosítás",
        "insurance-GKV": "Kötelező egészségbiztosítás",
        "insurance-PKV": "Magán-egészségbiztosítás",
        "insurance-SELFPAY": "Önfizető",
        "change-time": "Időpont módosítása",
        "description-free-text": "Egyéb megjegyzés (nem kötelező)",
        "note-wheelchair": "Kerekesszéket használok",
        "note-companion": "Kísérővel érkezem",
        "note-interpreter": "Tolmácsra van szükségem"
      },
      "done": {
        "title": "Időpont lefoglalva!",
        "label": "Lefoglalva",
        "subtitle": "Időpontja sikeresen lefoglalva.",
        "date": "Dátum",
        "time": "Idő",
        "booking-id": "Foglalási szám",
        "qr-hint": "Hozzáadás a naptárhoz",
        "qr-description": "Olvassa be ezt a QR kódot okostelefonja kamerájával az időpont naptárba való hozzáadásához",
        "auto-redirect": "Hamarosan átirányításra kerül a kezdőlapra...",
        "auto-redirect-countdown": "Visszatérés a kezdőlapra {{seconds}} másodperc múlva...",
        "back-to-start": "Vissza a kezdőlapra",
        "print-button": "Időpontlap nyomtatása",
        "print-preparing": "Nyomtatási nézet előkészítése…",
        "print-error": "Az időpontlapot nem sikerült megnyitni. Próbálja újra, vagy kérjen segítséget a recepción.",
        "print-returned": "A rendszer nyomtatási nézete bezárult. Szükség esetén újabb példányt kérhet.",
        "print-title": "Az Ön időpontja",
        "print-location": "Helyszín",
        "print-map-hint": "Helyszín megnyitása a telefonon",
        "print-error-v2": "Az időpontcédulát nem sikerült megnyitni. Kérjük, próbálja újra, vagy kérdezzen a recepción."
      },
      "error": {
        "assistance-info": "Nem tudtuk megerősíteni a foglalását. Lehet, hogy az időpont már le van foglalva. Kérjük, kérdezzen a recepción.",
        "pending-title": "A foglalás nincs megerősítve",
        "pending-info": "Nem tudtuk megerősíteni a foglalását. Lehet, hogy az időpont már le van foglalva. Kérjük, ellenőrizze újra, vagy kérdezzen a recepción.",
        "title": "Foglalás sikertelen",
        "subtitle": "Az időpontot nem sikerült lefoglalni.",
        "info": "Kérjük, próbálja újra, vagy kérdezzen a recepción."
      },
      "phase": {
        "identify": "Bejelentkezés",
        "choose": "Időpont választása",
        "confirm": "Megerősítés"
      }
    },
    "prescription": {
      "start": {
        "title": "Receptek és rendelés",
        "subtitle": "Helyezze be biztosítási kártyáját a receptek megtekintéséhez vagy az utántöltések megrendeléséhez.",
        "button": "Helyezze be a kártyát"
      },
      "card-check": {
        "loading": "Kártyaolvasó betöltése...",
        "no-terminal": "Nincs konfigurálva kártyaolvasó",
        "no-terminal-hint": "Kérjük, forduljon a személyzethez segítségért.",
        "insert-card": "Kérjük, helyezze be a kártyáját",
        "insert-card-hint": "Helyezze be biztosítási kártyáját a kártyaolvasóba.",
        "card-detected": "Kártya észlelve",
        "reading": "Olvasókártya...",
        "reading-hint": "Kérem, várjon egy pillanatot.",
        "error": "Hiba a kártya olvasásakor",
        "retry": "Próbáld újra",
        "manual-lookup": "Folytatás kártya nélkül",
        "load-error": "Nem sikerült betölteni a kártyaolvasót",
        "read-error": "A kártya nem olvasható"
      },
      "patient-selection": {
        "title": "Válassza a Beteg lehetőséget",
        "subtitle": "Több beteget találtak. Kérjük, válassza ki a nevét.",
        "try-again": "Próbáld újra",
        "try-again-hint": "Helyezze be újra a kártyát"
      },
      "list": {
        "title": "Az Ön receptjei",
        "for-patient": "Az {{name}} előírásai",
        "loading": "Receptek betöltése...",
        "error-title": "Betöltési hiba",
        "fetch-error": "A recepteket nem sikerült betölteni",
        "back-home": "Vissza a kezdéshez",
        "done": "Kész"
      },
      "detail": {
        "prescription-info": "Vényköteles információk",
        "date": "Dátum",
        "prescriber": "Felíró",
        "comment": "Megjegyzés",
        "medications": "Gyógyszerek",
        "form": "Űrlap",
        "pack-size": "Csomag mérete",
        "manufacturer": "Gyártó",
        "loading": "Vény betöltése...",
        "fetch-error": "A recept részleteit nem sikerült betölteni",
        "back-to-list": "Vissza a listához",
        "print": "Nyomtatás"
      },
      "types": {
        "public": "Nyilvános vényköteles",
        "private": "Privát recept",
        "long-term": "Hosszú távú vényköteles",
        "btm": "Kábítószer-recept",
        "g": "Zöld recept",
        "t": "T-recept"
      },
      "no-patient": {
        "title": "A páciens nem található",
        "subtitle": "Sajnos nem találtak pácienst ehhez a kártyához. Kérjük, forduljon a személyzethez segítségért.",
        "try-again": "Próbáld újra",
        "back-home": "Vissza a kezdéshez",
        "title-v2": "Nincs egyező adat",
        "subtitle-v2": "Nem találtuk meg Önt. Kérjük, próbálja újra, vagy kérdezzen a recepción."
      },
      "done": {
        "title": "Köszönöm",
        "subtitle": "Most már foglalhat helyet. Ha kérdése van, forduljon a személyzethez.",
        "no-prescriptions-title": "Nincsenek receptek az aktában",
        "no-prescriptions-subtitle": "Nem találtunk Önnek aktív receptet. Ha erre számított, forduljon a recepció személyzetéhez.",
        "error-title": "Hiba történt",
        "error-subtitle": "További segítségért forduljon a személyzethez.",
        "auto-redirect": "Automatikus átirányítás {{seconds}} másodpercben",
        "finish": "Vissza a kezdéshez"
      },
      "hub": {
        "title": "Az Ön receptjei",
        "for-patient": "Az {{name}} előírásai",
        "loading": "Receptek betöltése...",
        "error-title": "Betöltési hiba",
        "fetch-error": "Nem sikerült betölteni a recepteket",
        "back-home": "Vissza a kezdéshez",
        "done": "Kész",
        "order-button": "Rendeljen Vényköteles",
        "existing-prescriptions": "Jelenlegi receptjei",
        "no-prescriptions": "Nem találhatók aktív receptek."
      },
      "patient-lookup": {
        "title": "Keresse meg a pácienst",
        "subtitle": "Adja meg nevét és születési dátumát.",
        "last-name": "Vezetéknév",
        "first-name": "Keresztnév",
        "date-of-birth": "Születési dátum",
        "lastname": "Vezetéknév",
        "lastname-placeholder": "A vezetékneved",
        "firstname": "Keresztnév",
        "firstname-placeholder": "A keresztneved",
        "dob": "Születési dátum",
        "search": "Keresés",
        "searching": "Keresés...",
        "search-error": "Keresési hiba: {{message}}",
        "no-match": "Nem található beteg. Kérjük, ellenőrizze adatait.",
        "error": "Keresési hiba. Kérjük, próbálja újra.",
        "found": "Beteg találva",
        "confirm": "Erősítse meg",
        "ambiguous": "Több mérkőzés",
        "ambiguous-hint-firstname": "Kérjük, adja meg keresztnevét is a keresés finomításához.",
        "ambiguous-hint-additional": "Kérjük, ellenőrizze adatait, vagy lépjen kapcsolatba a személyzettel.",
        "not-found": "A páciens nem található",
        "not-found-hint": "Ezekkel az adatokkal nem találtak beteget.",
        "not-found-action": "Próbáld újra"
      },
      "manual-identification": {
        "unverified": "Az Ön személyazonosságát nem erősítették meg az egészségbiztosítási kártyával. A rendelő feldolgozás előtt ellenőrzi az adatait és a kérelmét."
      },
      "medication-selection": {
        "title": "Kérjen receptet",
        "subtitle": "Az orvosi rendelő felülvizsgálja a kérelmét. Jóváhagyás után az eRx készen áll az e-prescription alkalmazásban.",
        "back": "Vissza",
        "submit": "Folytassa az áttekintést",
        "reason-title": "Miért van szüksége a receptre?",
        "reason-hint": "Segít az orvosi rendelőnek a kérelem értékelésében.",
        "reason-validation": "Kérjük, válasszon okot.",
        "reason-schmerzen": "Fájdalom",
        "reason-entzuendung": "Gyulladás",
        "reason-nachsorge": "Műtét/eljárás után",
        "reason-allergie": "Allergia/reakció",
        "reason-chronisch": "Krónikus állapot",
        "reason-anderes": "Valami mást",
        "medications-title": "Milyen gyógyszereket?",
        "request-hint": "Írja le, mire van szüksége, vagy nevezze meg a korábbi, megújítani kívánt receptet.",
        "request-placeholder": "pl. Ibuprofen 600 mg, ugyanaz, mint legutóbb",
        "request-validation": "Kérjük, írja le, milyen gyógyszerre van szüksége.",
        "history-title": "Korábbi receptek",
        "history-hint": "Adjon hozzá egy bejegyzést a kérés előzetes kitöltéséhez.",
        "history-loading": "Korábbi receptek betöltése...",
        "history-error": "A korábbi recepteket nem lehetett betölteni.",
        "history-add": "Hozzáadás",
        "history-added": "Hozzáadva",
        "history-date": "Utolsó: {{date}}",
        "history-request-line": "Megújítás: {{medicationName}}",
        "urgency-title": "Mennyire sürgős?",
        "urgency-hint": "Segít az orvosi rendelőnek a prioritás meghatározásában.",
        "urgency-soon": "Sürgős",
        "urgency-soon-meta": "Amint lehet",
        "urgency-tomorrow": "Hamarosan",
        "urgency-tomorrow-meta": "A következő napokban",
        "urgency-week": "Ezen a héten",
        "urgency-week-meta": "Nincs időnyomás",
        "lead": "A rendelő ellenőrzi a kérését. Jóváhagyás után az e-receptet az e-recept alkalmazásban vagy az egészségbiztosítási kártyáján találja.",
        "history-hint-v2": "Koppintson egy korábbi receptre az átvételhez.",
        "history-retry": "Újratöltés"
      },
      "request-review": {
        "title": "Megrendelés áttekintése",
        "subtitle": "Kérjük, tekintse át receptigényét.",
        "request-label": "Kért gyógyszert",
        "selected-medications": "Válogatott gyógyszerek",
        "free-text-medications": "További gyógyszerek",
        "freetext-label": "Egyéb",
        "quarterly-warning": "A biztosítási kártyáját ebben a negyedévben nem olvasták be. Az orvosi rendelő felveheti Önnel a kapcsolatot.",
        "egk-warning": "A biztosítási kártyáját ebben a negyedévben nem olvasták be. Az orvosi rendelő felveheti Önnel a kapcsolatot.",
        "submit": "Beküld",
        "submitting": "Beküldés...",
        "submit-error": "Nem sikerült benyújtani a kérelmet. Kérjük, próbálja újra.",
        "back": "Vissza",
        "reason-label": "Ok",
        "urgency-label": "Sürgősség",
        "completion-email-choice": "E-mailt szeretnék kapni, amikor a rendelő feldolgozta a kérésemet.",
        "completion-email-label": "E-mail-cím",
        "completion-email-placeholder": "nev@pelda.hu",
        "completion-email-hint": "Csak ehhez az egyszeri üzenethez. A cím nem kerül mentésre törzsadatként.",
        "completion-email-invalid": "Adjon meg érvényes e-mail-címet.",
        "egk-proof-required": "Receptigénylés csak a biztosítási kártya sikeres beolvasása után lehetséges. Kérjük, forduljon a személyzethez.",
        "title-v2": "Kérés ellenőrzése",
        "completion-email-hint-v2": "A címet csak erre az egy üzenetre használjuk."
      },
      "confirmation": {
        "title": "Kérelem elküldve",
        "subtitle": "Receptigényét sikeresen elküldtük.",
        "success-title": "Kérelem elküldve",
        "success-subtitle": "Receptigényét sikeresen elküldtük.",
        "estimated-time": "A recept körülbelül {{time}} alatt elkészül.",
        "info": "Vegyét a gyógyszertárban veheti át biztosítási kártyájával vagy az eRezept alkalmazással.",
        "auto-redirect": "Automatikus átirányítás {{seconds}} másodpercben",
        "back-to-start": "Vissza a kezdéshez",
        "handling-label": "Handled by the practice",
        "next-steps": "A rendelő ellenőrzi a kérését. Jóváhagyás után az e-receptet a gyógyszertárban válthatja ki egészségbiztosítási kártyájával vagy az e-recept alkalmazással."
      },
      "phase": {
        "identify": "Bejelentkezés",
        "request": "Kérés",
        "review": "Ellenőrzés"
      }
    },
    "check-in": {
      "flow-label": "Bejelentkezés",
      "has-appointment": {
        "eyebrow": "Kinevezés",
        "title": "Van időpontja?",
        "subtitle": "Kérjük, válasszon egy lehetőséget",
        "yes-label": "Igen",
        "yes": "Igen, van időpontom",
        "yes-description": "Be szeretnék jelentkezni az időpontomra.",
        "yes-hint": "Leggyorsabb út",
        "unsure-label": "Talán",
        "unsure": "Nem vagyok biztos benne",
        "unsure-description": "Ellenőrizzük Önnek.",
        "unsure-hint": "Megkeresünk",
        "no-label": "Nem",
        "no": "Nem, nincs időpontom",
        "no-description": "Nincs időpontom.",
        "no-hint": "Bejárás"
      },
      "card-check": {
        "eyebrow": "Biztosítási kártya",
        "title": "Egészségbiztosítási kártya beolvasása",
        "subtitle": "Kérjük, helyezze be egészségbiztosítási kártyáját az olvasóba",
        "insert-title": "Helyezze be egészségbiztosítási kártyáját a kártyaolvasóba.",
        "insert-detail": "Automatikusan beolvasjuk adatait – nem kell mást tennie.",
        "other-ways": "Más módokon",
        "no-card-hint": "Ha most nincs nálad a kártya.",
        "pkv-hint": "Használja az QR code-et a biztosítási alkalmazással.",
        "loading": "Beállítások betöltése...",
        "no-terminal": "Nincs beállítva kártyaolvasó. Kérjük, forduljon a személyzethez.",
        "checking": "Kártyák ellenőrzése...",
        "insert-prompt": "Kérjük, helyezze be a kártyát...",
        "card-detected": "Kártya észlelve! Olvasásra kész.",
        "read-card": "Kártya beolvasása",
        "simulate-insert": "Kártya szimulálása",
        "reading": "Kártya olvasása...",
        "error": "Nem sikerült beolvasni a kártyát. Kérjük, próbálja újra.",
        "read-error": "Hiba a kártya adatainak olvasásakor. Kérjük, próbálja újra.",
        "settings-error": "Nem sikerült betölteni a beállításokat. Kérjük, próbálja újra.",
        "no-card-prompt": "Nincs nála a kártyája?",
        "no-card-action": "Kézi keresés",
        "connection-warning": "Csatlakozási problémák a kártyaolvasóval. Kérem, várjon...",
        "pkv-prompt": "Magánbiztosítás? Online Check-in",
        "pkv-instruction": "Olvassa be ezt az QR code készüléket saját egészségbiztosítási alkalmazásával, hogy digitálisan továbbítsa adatait.",
        "pkv-continue": "Folytassa a kézi regisztrációval",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Kérjük, próbálja újra, vagy jelentkezzen be kártya nélkül. A recepció szívesen segít.",
        "title-pkv": "Bejelentkezés alkalmazással",
        "title-reading": "Kártyája beolvasása …",
        "title-unreadable": "A kártyát nem sikerült beolvasni",
        "title-no-terminal": "Bejelentkezés kártya nélkül",
        "no-terminal-body": "A kártyaolvasó most nem érhető el. Kérjük, jelentkezzen be kártya nélkül, vagy forduljon a recepcióhoz.",
        "reading-detail": "Kérjük, hagyja a kártyát az olvasóban. Csak egy pillanat.",
        "other-ways-title": "Egyéb lehetőségek",
        "no-card-title": "Bejelentkezés kártya nélkül",
        "pkv-prompt-title": "Magánbiztosított?",
        "pkv-prompt-hint": "Bejelentkezés magán egészségbiztosítója alkalmazásával",
        "pkv-close": "Mégis kártyával",
        "pkv-instruction-app": "Nyissa meg magán egészségbiztosítója alkalmazását, és olvassa be ezt a kódot. Adatai ezután közvetlenül hozzánk érkeznek."
      },
      "patient-selection": {
        "title": "Válassza ki a pácienst",
        "subtitle": "Több páciens található. Kérjük, válassza ki magát.",
        "firstname-label": "A keresztneved",
        "firstname-placeholder": "Adja meg a keresztnevet...",
        "confirm-button": "Erősítse meg",
        "no-match": "Nem található megfelelő páciens. Kérjük, forduljon a recepcióhoz segítségért.",
        "still-ambiguous": "Több meccs maradt. Kérjük, forduljon a recepcióhoz segítségért.",
        "select-error": "Nem sikerült azonosítani a pácienst. Kérjük, próbálja újra.",
        "staff-assist": "Menjen a recepcióra",
        "title-v2": "Rövid kérdés",
        "subtitle-v2": "A biztonság kedvéért adja meg keresztnevét.",
        "no-match-v2": "Ezzel a keresztnévvel nem találtuk meg. Ellenőrizze a helyesírást, vagy forduljon a recepcióhoz.",
        "still-ambiguous-v2": "Még nem tudtuk egyértelműen azonosítani. Kérjük, forduljon a recepcióhoz.",
        "select-error-v2": "Ez sajnos nem sikerült. Kérjük, próbálja újra."
      },
      "card-checkin": {
        "title": "Bejelentkezés megerősítése",
        "subtitle": "Adatai sikeresen beolvasva.",
        "confirm": "Bejelentkezés megerősítése"
      },
      "register-from-card": {
        "title": "Új regisztráció",
        "subtitle": "Még nincs a rendszerünkben. Szeretne regisztrálni?",
        "card-data": "Kártya adatok",
        "create": "Regisztráció",
        "create-error": "A regisztráció sikertelen. Kérjük, próbálja újra, vagy kérjen segítséget a személyzettől.",
        "staff-assist": "Hívja a személyzetet",
        "no-card-data-title": "Nincs kártyaadat",
        "no-card-data": "Nem sikerült beolvasni az adatokat a kártyájáról.",
        "insurance-verified": "Biztosítás igazolva: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Adatai a kártyáról",
        "subtitle-v2": "Kérjük, ellenőrizze adatait. Ha valami nem stimmel, koppintson a „Módosítás” gombra.",
        "create-v2": "Adatok megerősítése",
        "create-error-v2": "A bejelentkezés sajnos nem sikerült. Próbálja újra, vagy forduljon a recepcióhoz.",
        "insurer-missing-v2": "Kártyáján nem szerepel az egészségbiztosító. Kérjük, forduljon a recepcióhoz.",
        "edit": "Módosítás",
        "name": "Név",
        "insurer": "Egészségbiztosító"
      },
      "patient-lookup": {
        "title": "Páciens keresése",
        "subtitle": "Kérjük, adja meg nevét vagy biztosítási számát.",
        "lastname": "Vezetéknév",
        "lastname-placeholder": "A vezetékneved",
        "dob": "Születési dátum",
        "firstname": "Keresztnév",
        "firstname-placeholder": "A keresztneved",
        "search": "Keresés",
        "searching": "Keresés...",
        "search-placeholder": "Név vagy biztosítási szám...",
        "results-placeholder": "A keresési eredmények itt jelennek meg",
        "found": "Beteg találva!",
        "confirm-identity": "Kérjük, erősítse meg, hogy Ön a bemutatott beteg.",
        "confirm-button": "Ez vagyok én",
        "ambiguous-firstname": "Több beteget találtak. Kérjük, adja meg keresztnevét.",
        "ambiguous-additional": "Több beteget találtak. Kérjük, lépjen kapcsolatba a személyzettel.",
        "disambiguation-hint": "Ez segít nekünk egyértelműen azonosítani Önt.",
        "not-found": "Ezekkel az adatokkal nem találtak beteget.",
        "error": "Keresési hiba: {{message}}",
        "staff-assist": "Hívja a személyzetet",
        "not-found-prompt": "Nem található?",
        "register-new": "Új regisztrálása",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Bejelentkezés kártya nélkül",
        "subtitle-firstname": "Kérjük, adja meg keresztnevét is.",
        "ambiguous-firstname-v2": "Több személy is ezt a vezetéknevet viseli. Kérjük, adja meg keresztnevét is.",
        "search-again": "Újrakeresés",
        "found-v2": "Megtaláltuk",
        "found-confirm": "Kérjük, erősítse meg az „Ez vagyok én” gombbal.",
        "not-found-title": "Nem találtuk meg",
        "not-found-check": "Ellenőrizze a helyesírást és a születési dátumot. A recepció szívesen segít.",
        "not-found-reception": "Ellenőrizze a helyesírást és a születési dátumot, vagy forduljon a recepcióhoz.",
        "ambiguous-additional-v2": "Nem tudtuk egyértelműen azonosítani. Kérjük, forduljon a recepcióhoz.",
        "error-v2": "A keresés most nem sikerült. Kérjük, próbálja újra."
      },
      "checking-in": {
        "title": "Egy pillanat – bejelentkezünk.",
        "subtitle": "Felvesszük a kezelési sorba és értesítjük a csapatot.",
        "step-insurance": "Biztosítás ellenőrizve",
        "step-appointment": "A kinevezés megerősítve",
        "step-waitlist": "Felvétel a várólistára",
        "error": "A bejelentkezés sikertelen. Kérjük, próbálja újra.",
        "continue": "Mindenképpen folytasd",
        "title-v2": "Egy pillanat",
        "loading": "Bejelentkeztetjük …",
        "subtitle-v2": "Felvesszük a várólistára, és szólunk a csapatnak.",
        "error-title": "Ez sajnos nem sikerült",
        "error-v2": "A bejelentkezést nem sikerült befejezni.",
        "error-body": "Kérjük, próbálja újra. Ha ismét nem sikerül, a recepció segít."
      },
      "appointment-selection": {
        "title": "Válasszon időpontot",
        "subtitle": "Ma több találkozód van. Kérjük, válasszon egyet.",
        "checking-in": "Bejelentkezés...",
        "time": "{{time}}",
        "error-v2": "Az erre az időpontra szóló bejelentkezés nem sikerült. Próbálja újra, vagy forduljon a recepcióhoz."
      },
      "no-appointment": {
        "title": "Nem találtunk időpontot",
        "subtitle": "Ma nem találtunk Önnek időpontot. Kérjük, foglaljon rendszeres időpontot.",
        "book-appointment": "Foglaljon időpontot",
        "book-appointment-description": "Foglaljon új időpontot a szokásos ütemezőn keresztül.",
        "staff-assist": "Hívja a személyzetet",
        "staff-assist-description": "segítségre van szükségem.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Mára nem találtunk Önnek időpontot.",
        "book-v2": "Új időpont foglalása",
        "book-v2-description": "Válasszon most egy szabad időpontot.",
        "have-appointment": "Van időpontom",
        "have-appointment-description": "A recepció szívesen segít.",
        "unavailable-title": "Időpontot kérjük a recepción foglaljon",
        "subtitle-unavailable": "Mára nem találtunk Önnek időpontot. Kérjük, forduljon a recepcióhoz."
      },
      "staff-assist": {
        "title": "A személyzet értesítette",
        "subtitle": "A személyzet egyik tagja hamarosan segít Önnek.",
        "message": "Kérjük, várjon itt. Egy munkatárs hamarosan Önnel érkezik.",
        "start-over": "Vissza a kezdéshez",
        "auto-redirect": "{{seconds}} másodperc múlva visszatér a kezdéshez..."
      },
      "eeb-prompt": {
        "title": "Biztosítás ellenőrzése",
        "title-failed": "Ellenőrzés sikertelen",
        "subtitle": "Hogyan szeretné ellenőrizni biztosítását?",
        "subtitle-failed": "Olvassa be a QR kódot biztosítási alkalmazásával az ellenőrzés kéréséhez.",
        "verify-card": "Elektronikus ellenőrzés",
        "verify-card-description": "Kérés küldése biztosítójának.",
        "select-insurer": "Biztosító kiválasztása",
        "select-insurer-description": "Biztosítójának kézi kiválasztása.",
        "skip": "Kihagyás",
        "eyebrow-chip": "Alternatív",
        "eyebrow": "Bejelentkezés · biztosítási igazolás (eEB)",
        "recommended": "Ajánlott",
        "qr-title": "Olvassa be a biztosítási alkalmazással",
        "qr-description": "Nyissa meg egészségbiztosítási alkalmazását, és olvassa be a kódot – az eEB közvetlenül hozzánk kerül.",
        "qr-address-label": "Küldje el",
        "title-app": "Igazolás alkalmazással",
        "subtitle-app": "Biztosítója az igazolást közvetlenül is elküldheti nekünk. Ha kész, koppintson a „Tovább” gombra."
      },
      "quarterly-check": {
        "title": "Biztosítás ellenőrzése",
        "checking": "Jelenlegi biztosítási ellenőrzés folyamatban...",
        "error": "Az ellenőrzés nem hajtható végre.",
        "title-v2": "Az Ön biztosítása",
        "checking-v2": "Ellenőrizzük biztosítását – egy pillanat.",
        "error-body": "Bejelentkezése kész. A biztosítást a recepció tisztázza Önnel."
      },
      "insurer-prefilled": {
        "title": "Egészségbiztosítása",
        "subtitle": "Kérjük, erősítse meg biztosítását erre a negyedévre.",
        "your-insurance": "Az Ön biztosítása",
        "last-read": "Utoljára ellenőrizve: {{date}}",
        "quarterly-notice": "Számlázási célokból szükségünk van aktuális biztosítási igazolásra erre a negyedévre.",
        "confirm-button": "Igen, ez az én biztosításom",
        "change-button": "Más biztosításom van",
        "contact-title": "Kérjen elektronikus igazolást a fedezetről",
        "contact-description": "Hívja biztosítóját, és kérjen elektronikus igazolást a fedezetről:",
        "contact-patient": "Beteg",
        "contact-kim-address": "Az orvosi rendelő KIM címe",
        "contact-phone": "Phone",
        "question": "Ez az Ön egészségbiztosítója?",
        "quarterly-notice-v2": "Negyedévente egyszer igazolásra van szükségünk az egészségbiztosítójától."
      },
      "insurer-search": {
        "title": "Válassza ki egészségbiztosítását",
        "subtitle": "Kérjük, keresse meg és válassza ki kötelező egészségbiztosítását.",
        "placeholder": "Biztosítás keresése...",
        "hint": "Adjon meg legalább 2 karaktert a kereséshez.",
        "no-results": "Nem található biztosítás.",
        "no-results-hint": "Ellenőrizze a helyesírást, vagy próbáljon másik keresést.",
        "label": "Egészségbiztosítója neve",
        "search-error-v2": "A keresés most nem sikerült. Kérjük, próbálja újra.",
        "app-alternative": "Inkább biztosítója alkalmazásával?"
      },
      "insurer-contact": {
        "title": "Kérjen biztosítási igazolást",
        "subtitle": "Kérjük, válasszon az alábbi lehetőségek közül.",
        "or": "vagy",
        "option-eeb-title": "Érdeklődni elektronikusan",
        "option-eeb-description": "Ha fennáll a törvényi kivételes eset, hozzájárulása után átadhatja a kérelmet a rendelő csapatának.",
        "option-qr-title": "Szkennelés alkalmazással",
        "option-qr-description": "Olvassa be az QR code-et a biztosítási alkalmazással.",
        "option-call-title": "Hívd fel magad",
        "option-call-description": "Hívja fel a biztosítóját, és kérjen eEB-t ehhez az orvosi rendelőhöz:",
        "phone": "Phone",
        "phone-not-available": "Telefonszám a biztosítási kártyáján",
        "patient-name": "Beteg",
        "practice-kim": "Az orvosi rendelő KIM címe",
        "help-notice": "Ha bármilyen problémája van, kérjük, keresse fel a recepciót.",
        "submit-eeb-button": "Kérjen most",
        "contacted-button": "felhívtam",
        "contacted-button-countdown": "A hívás ideje ({{seconds}}s)",
        "go-to-counter-button": "Menjen a recepcióra",
        "qr-continue-button": "beszkenneltem",
        "qr-continue-button-countdown": "Beolvasási idő ({{seconds}}s)",
        "title-v2": "Igazolás az egészségbiztosítójától",
        "subtitle-v2": "A legegyszerűbb biztosítója alkalmazásával.",
        "subtitle-no-app": "Válassza ki, hogyan küldje el nekünk biztosítója az igazolást.",
        "option-eeb-description-v2": "Mi kérjük meg biztosítóját az Ön nevében. Ehhez a hozzájárulására van szükségünk.",
        "call-instruction": "Hívja fel egészségbiztosítóját, és kérje, hogy küldjék el az igazolást a rendelőnknek.",
        "call-instruction-practice": "Hívja fel egészségbiztosítóját, és kérje, hogy küldjék el az igazolást a(z) {{practice}} rendelőnek.",
        "done-button": "Kész – tovább",
        "done-button-countdown": "Kész – tovább (még {{seconds}} mp)"
      },
      "eeb-consent": {
        "title": "Hozzájárulás",
        "subtitle": "Szükségünk van hozzájárulására az elektronikus biztosítás ellenőrzéséhez.",
        "insurance": "Az Ön biztosítása",
        "consent-title": "Hozzájárulás az elektronikus biztosítás ellenőrzéséhez (eEB)",
        "consent-text": "Tudomásul veszem, hogy az egészségbiztosítóm a biztosítási adataimat (pl. név, születési dátum, biztosítási szám) a biztonságos KIM kommunikációs szolgáltatáson keresztül az {{practiceName}} orvosi rendelőnek továbbítja biztosítási igazolásként. Hozzájárulok ehhez az adattovábbításhoz. Tudomásul veszem, hogy ezt a hozzájárulást bármikor visszavonhatom anélkül, hogy ez befolyásolná a kezelésemet.",
        "withdrawal-notice": "Ezt a hozzájárulást bármikor visszavonhatja.",
        "agree-button": "Hozzájárulok",
        "decline-button": "Mégse",
        "treatment-notice": "Kezelését nem befolyásolja ez a hozzájárulás.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Igazolás az egészségbiztosítójától",
        "summary": "Biztosítója közvetlenül elküldi nekünk az igazolást. Ehhez a hozzájárulására van szükségünk.",
        "confirm-first": "Kérjük, először erősítse meg a nyilatkozatot."
      },
      "qr-code": {
        "title": "Beolvasás biztosítási alkalmazással",
        "instruction-1": "Nyissa meg biztosítási alkalmazását és olvassa be ezt a QR kódot.",
        "instruction-2": "Az orvosi rendelő ezután automatikusan megkapja a biztosítási ellenőrzését.",
        "practice": "Orvosi rendelő: {{name}}",
        "alternative-hint": "Alternatíva: Használja biztosítási alkalmazását",
        "instruction-app": "Nyissa meg egészségbiztosítója alkalmazását, és olvassa be ezt a kódot. Az igazolás ezután közvetlenül hozzánk érkezik.",
        "staff-line": "A rendelő csapatának: {{address}}",
        "staff-line-practice": "A rendelő csapatának: {{name}} · {{address}}",
        "alternative-app": "Az igazolást biztosítója alkalmazásával is kérheti: nyissa meg az alkalmazást, és olvassa be ezt a kódot."
      },
      "register-basics": {
        "title": "Személyes adatok",
        "subtitle": "Kérjük, adja meg adatait.",
        "family-name": "Vezetéknév",
        "given-name": "Keresztnév",
        "dob": "Születési dátum",
        "gender": "Nem",
        "insurance-type": "Biztosítás típusa",
        "insurer-name": "Biztosításod neve",
        "insurer-name-placeholder": "pl. Debeka, DKV, Allianz...",
        "gender-required": "Kérjük, válasszon egy lehetőséget."
      },
      "register-insurer": {
        "title": "Egészségbiztosítás",
        "subtitle": "Kérjük, válassza ki egészségbiztosítását.",
        "search-placeholder": "Biztosítás keresése..."
      },
      "register-details": {
        "title": "Összefoglaló",
        "subtitle": "Kérjük, ellenőrizze adatait.",
        "create": "Regisztráció befejezése",
        "missing-data": "Kérjük, töltse ki az összes kötelező mezőt.",
        "create-error": "A regisztráció sikertelen. Kérjük, próbálja újra.",
        "policy-number": "kötvényszám (nem kötelező)",
        "policy-number-placeholder": "Az Ön kötvényszáma",
        "create-v2": "Bejelentkezés befejezése",
        "policy-number-hint": "A számot biztosítási kártyáján találja."
      },
      "diff-review": {
        "eyebrow-chip": "Tekintse át",
        "eyebrow": "Bejelentkezés · kártyaadatok",
        "title": "Adatok összehasonlítása",
        "subtitle": "Eltérések találhatók kártyája adatai és nyilvántartásunk között.",
        "col-current": "Aktuális rekord",
        "col-new": "Új kártyáról",
        "new-badge": "új",
        "field-fallback": "Mező",
        "note": "A frissített adatok segítenek abban, hogy helyesen számlázzuk, és vészhelyzetben elérjük Önt.",
        "comparison-placeholder": "Az összehasonlítás itt jelenik meg",
        "confirm": "Változtatások megerősítése",
        "apply-error": "Az adatokat nem lehetett alkalmazni. Kérjük, próbálja újra.",
        "retry": "Próbáld újra",
        "skip": "Mindenképpen folytasd",
        "no-changes": "Nem találhatók változtatások",
        "title-v2": "Adatai megváltoztak",
        "subtitle-v2": "Kártyáján újabb adatok szerepelnek. Átvegyük őket?",
        "confirm-v2": "Átvétel és bejelentkezés",
        "keep": "Bejelentkezés változtatás nélkül",
        "col-current-v2": "Eddig",
        "col-new-v2": "Új a kártyáról",
        "value-yes": "Igen",
        "value-no": "Nem"
      },
      "insurance-selection": {
        "title": "Biztosítás típusa",
        "subtitle": "Kérjük, válassza ki biztosítása típusát.",
        "gkv": "Kötelező biztosított",
        "gkv-description": "Kötelező egészségbiztosítás tagja.",
        "pkv": "Magán vagy önfizetés",
        "pkv-description": "Magánbiztosított vagy önfizető.",
        "pkv-description-v2": "Magán egészségbiztosítás, vagy Ön fizet."
      },
      "eeb-request": {
        "title": "Kérelem rögzítve",
        "subtitle": "Befejezheti a bejelentkezést. A(z) {{insurer}} válasza később érkezik meg a rendelőbe.",
        "verifying": "Kérelmét azonnali feldolgozásra elfogadtuk.",
        "success": "Kérelmét biztonságosan átadtuk a rendelő csapatának.",
        "error": "A kérelem visszaigazolása nem érhető el.",
        "try-alternative": "Alternatív módszer",
        "kim-load-error": "Az orvosi rendelő KIM címe nem tölthető be.",
        "kim-label": "Orvosi rendelő · KIM",
        "non-blocking-note": "Ez még nem igazolja vissza az egészségbiztosítójához való megérkezést, sem a biztosítási státuszát.",
        "auto-continue": "Automatikus továbblépés {{seconds}} másodperc múlva.",
        "unavailable-title": "Ez sajnos nem sikerült",
        "unavailable-v2": "Az egészségbiztosítónak szóló kérelmét nem sikerült rögzíteni.",
        "unavailable-body": "Az igazolást kérheti biztosítója alkalmazásával, vagy elintézheti a recepción.",
        "use-app": "Alkalmazással",
        "at-reception": "Elintézés a recepción"
      },
      "self-pay": {
        "title": "Önfizetés",
        "subtitle": "Önfizető páciensként lesz kezelve.",
        "info": "Kérjük, vegye figyelembe, hogy Ön lesz felelős a kezelés költségeiért.",
        "confirm": "Értem",
        "title-v2": "Ön fizet",
        "subtitle-v2": "A kezelést Ön fizeti.",
        "insured-after-all": "Mégis biztosított vagyok"
      },
      "done": {
        "title": "Kész!",
        "subtitle": "A bejelentkezés befejeződött.",
        "finish": "Befejezés",
        "done-label": "Kész",
        "error-label": "Megjegyzés",
        "eyebrow": "Bejelentkezés · kész",
        "queue-label": "Váróterem",
        "queue-title": "Kérem, foglaljon helyet",
        "queue-meta": "Személyesen hívjuk.",
        "success-title": "Sikeres bejelentkezés!",
        "success-subtitle": "Kérjük, foglaljon helyet a váróban. Hamarosan hívjuk.",
        "auto-redirect": "Hamarosan átirányításra kerül a kezdőlapra...",
        "auto-redirect-countdown": "{{seconds}} másodperc múlva visszatér a kezdéshez...",
        "card-expired-title": "Kártya lejárt",
        "card-expired-subtitle": "Egészségbiztosítási kártyája lejárt.",
        "card-expired-info": "Kérjük, forduljon a személyzethez segítségért.",
        "back-to-start": "Vissza a kezdőlapra",
        "anamnesis-title": "Teljes kórtörténeti űrlap",
        "anamnesis-description": "Olvassa be az QR code-et, hogy kényelmesen töltse ki kórtörténeti űrlapját okostelefonján.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Bejelentkezett",
        "card-expired-info-v2": "Kérjük, forduljon a recepcióhoz."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Ellenőrizze adatait",
          "balance-prefix": "Mentéskor:",
          "balance-direct-v2": "Azonnal mentve: {{count}}",
          "balance-reception-v2": "A recepció ellenőrzi: {{count}}",
          "chip-reception-v2": "A módosításokat recepciónk ellenőrzi",
          "chip-changed": "Módosítva: {{count}}",
          "remove": "Eltávolítás",
          "example-email": "pl. nev@pelda.hu",
          "example-phone": "pl. 06 30 123 4567",
          "intro-v2": "Bejelentkezése kész. Helyesek még ezek az adatok? Az ellenőrzés önkéntes.",
          "auto-hide": "A megjelenített értékek rövid idő után ismét elrejtődnek."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Ezt az adatot továbbítottuk a recepciónak.",
          "banner-done-v2": "Köszönjük! Megkaptuk adatait.",
          "footer-v2": "Minden más adat változatlan marad."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Adatvédelmi okokból bezártuk a megjelenítést. Bejelentkezése ettől függetlenül kész. Módosításokat bármikor jelezhet a recepción."
        }
      },
      "progress": {
        "identify": "Bejelentkezés",
        "insurance": "Biztosítás",
        "done": "Kész"
      },
      "dob-format-hint": "Például 01.10.1980",
      "dob-required": "Kérjük, adja meg születési dátumát.",
      "insurance-label": {
        "GKV": "Kötelező biztosítás",
        "PKV": "Magánbiztosítás",
        "SELFPAY": "Önfizető"
      }
    },
    "emergency": {
      "title": "Akut vészhelyzet!",
      "label": "Vészhelyzet",
      "subtitle": "Ez a jelzés csak helyben hallható, és nem hívott segítséget. Akut vagy potenciálisan életveszélyes esetben hívja a 112-t.",
      "call-emergency": "Hívja a segélyszolgálatot (112)",
      "stop-sound": "Hang leállítása",
      "play-sound": "Hang lejátszása",
      "back-to-start": "Vissza a kezdéshez",
      "headline": "Kérjük, azonnal forduljon a recepció személyzetéhez. Életveszély esetén hívja a 112-t."
    },
    "help-reception": "Recepciós segítség",
    "help-reception-toast": "Kérjük, forduljon a recepcióhoz. Szívesen segítünk.",
    "language-entry": {
      "title": "Válasszon nyelvet"
    },
    "loading": "Betöltés…",
    "step-progress-label": "Előrehaladás",
    "step-progress-phase": "{{current}}/{{total}}. szakasz: {{phase}}",
    "step-progress-substep": "{{current}}/{{total}}. rész",
    "step-progress-complete": "Befejezve",
    "identification": {
      "title": "Kicsoda Ön?",
      "lead": "Leggyorsabban az egészségbiztosítási kártyájával megy. Név alapján is kereshet.",
      "lead-card-only": "Kérjük, helyezze egészségbiztosítási kártyáját a kártyaolvasóba.",
      "mode-label": "Hogyan szeretne bejelentkezni?",
      "mode-card": "Kártyával",
      "mode-search": "Keresés név alapján",
      "mode-create": "Új a rendelőben",
      "card": {
        "loading": "Kártyaolvasó előkészítése …",
        "checking": "Kártyaolvasó ellenőrzése …",
        "insert-title": "Kérjük, helyezze egészségbiztosítási kártyáját a kártyaolvasóba.",
        "insert-detail": "Adatait automatikusan beolvassuk.",
        "detected": "Kártya felismerve",
        "read": "Kártya beolvasása",
        "reading": "Kártya beolvasása folyamatban …",
        "reading-hint": "Kérjük, hagyja a kártyát az olvasóban.",
        "no-terminal-title": "A kártyaolvasó nem érhető el",
        "help-with-search": "Kérjük, keressen név alapján, vagy kérdezzen a recepción.",
        "help-reception": "Kérjük, kérdezzen a recepción – szívesen segítünk.",
        "unreadable-title": "Kártya felismerve, de nem olvasható",
        "error-title": "A kártyát nem sikerült beolvasni",
        "not-unique": "Nem tudtuk egyértelműen Önhöz rendelni ezt a kártyát. Kérjük, keressen név alapján, vagy kérdezzen a recepción.",
        "no-match": "Ehhez a kártyához nem találtunk adatokat. Kérjük, keressen név alapján, vagy kérdezzen a recepción.",
        "without-card": "Tovább kártya nélkül"
      },
      "lookup": {
        "lead": "Kérjük, adja meg vezetéknevét és születési dátumát.",
        "first-name": "Keresztnév",
        "last-name": "Vezetéknév",
        "dob": "Születési dátum",
        "dob-hint": "Formátum: NN.HH.ÉÉÉÉ",
        "search": "Keresés",
        "confirm": "Igen, én vagyok",
        "found-title": "Megtaláltuk Önt",
        "found-body": "Kérjük, erősítse meg, hogy Önről van szó.",
        "first-name-needed-title": "Kérjük, adja meg keresztnevét",
        "first-name-needed-body": "Hogy egyértelműen megtaláljuk. Utána koppintson a „Keresés” gombra.",
        "ambiguous-title": "Nem találtuk meg Önt egyértelműen",
        "ambiguous-body": "Kérjük, kérdezzen a recepción – szívesen segítünk.",
        "not-found-title": "Nincs egyező adat",
        "not-found-body": "Kérjük, ellenőrizze a megadott adatokat.",
        "error-title": "A keresés most nem lehetséges",
        "error-body": "Kérjük, próbálja újra, vagy kérdezzen a recepción."
      },
      "create": {
        "insurance-question": "Hogyan biztosított?",
        "insurance-required": "Kérjük, válassza ki, hogyan biztosított.",
        "error-title": "Adatait nem sikerült menteni",
        "error-body": "Kérjük, próbálja újra, vagy kérdezzen a recepción."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Először oldja fel",
      "subtitle": "A FrontDesk+-t aktiválni kell a gyakorlati szoftverben.",
      "step1": "Rendeljen a SolStore-ban (vagy a Doc-Cirrus partnere megrendeli Önt).",
      "step2": "Az aktiválás után aktiválja a inSuite-ban a „inSuite Sols” alatt (adminisztrátori jogok).",
      "step3": "Nyissa meg a Bridge adminisztrációt → „Eszköz hozzáadása”.",
      "cta": "Minden kész - tovább"
    },
    "welcome": {
      "title": "Adja hozzá ezt az eszközt a gyakorlathoz",
      "scan": "Készítsen fényképet a kódról",
      "prepare-link": "Nincs kód a inSuite-ban?",
      "language": "Nyelv"
    },
    "scan": {
      "requesting": "Kamera hozzáférést kérünk…",
      "scanning": "Irányítsa a kamerát a kódra",
      "paste": "Helyette illessze be",
      "manual-title": "Csatlakoztassa manuálisan",
      "manual-description": "Ha a QR-kód nem áll rendelkezésre, vegye át a kapcsolati adatokat a Bridge adminisztrációjától.",
      "address-label": "Bridge cím",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Helyezze be a SOLTOKEN-t",
      "manual-submit": "Vegye át a kapcsolatot",
      "error-title": "A kód nem ismerhető fel",
      "camera-denied-title": "A kamera hozzáférés megtagadva",
      "camera-denied-hint": "Kérjük, engedélyezze a kamera hozzáférését a beállításokban, és próbálja újra.",
      "retry": "Próbáld újra"
    },
    "preflight": {
      "title": "Be lesz állítva",
      "all-green": "Minden teszt sikeres",
      "practice": "Gyakorlat",
      "device-name": "Eszköz neve",
      "device-name-placeholder": "például B. Fogadás 1",
      "card-reader": "Kártyaolvasó",
      "pin": "Új titkos szám",
      "pin-placeholder": "Négyjegyű PIN kód",
      "finish": "Befejezés",
      "recheck": "Ellenőrizze újra",
      "diagnosis": "Diagnózis azonosítója",
      "checklist-error": "A Bridge elutasította a kapcsolatot, vagy nem érhető el. Ellenőrizze a SOLTOKEN-t és a Bridge címét.",
      "checklist-retry": "Ellenőrzés újra",
      "edit-token": "SOLTOKEN módosítása",
      "rescan": "Kód újbóli beolvasása"
    },
    "persisting": "Beállítások mentése …",
    "success": {
      "title": "Eszköz hozzáadva",
      "detail": "A készülék most jelent meg a gyakorló PC-n.",
      "starting": "A beteg üzemmód elindul…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Csatlakozás a gyakorló szoftverhez",
        "fix": "Bridge Ellenőrizze a kapcsolatot és a szerver címét."
      },
      "missing_insuite_url": {
        "label": "inSuite cím",
        "fix": "Olvassa be újra a QR-kódot – a cím hiányzik."
      },
      "missing_server_token": {
        "label": "Szerver token",
        "fix": "Olvassa be újra a QR-kódot – a token hiányzik."
      },
      "missing_gateway_session": {
        "label": "Gateway munkamenet",
        "fix": "Jelentkezzen be újra – a munkamenet hiányzik."
      },
      "missing_gateway_enrollment": {
        "label": "Eszköz regisztráció",
        "fix": "Regisztrálja az eszközt a Gateway oldalon."
      },
      "gateway_not_ready": {
        "label": "Gateway készenlét",
        "fix": "Várja meg, amíg a Gateway befejezi a beállítást."
      },
      "token_verification_failed": {
        "label": "Token ellenőrzés",
        "fix": "Ellenőrizze a szerver tokent vagy a Bridge kapcsolatot."
      },
      "session_expired": {
        "label": "találkozó",
        "fix": "A munkamenet lejárt – jelentkezzen be újra."
      },
      "device_revoked": {
        "label": "Eszköz állapota",
        "fix": "Ez az eszköz le van tiltva. Contact the practice."
      },
      "missing_practice_name": {
        "label": "Gyakorló név",
        "fix": "Az orvosi rendelő nevét nem sikerült betölteni (inSuite)."
      },
      "missing_device_name": {
        "label": "Eszköz neve",
        "fix": "Kérjük, adja meg az eszköz nevét."
      },
      "telematik_unavailable": {
        "label": "Telematikai infrastruktúra",
        "fix": "Opcionális – a kártyaellenőrzés továbbra is lehetséges, amint a TI elérhető."
      },
      "selected_card_reader_unavailable": {
        "label": "Kártyaolvasó",
        "fix": "Opcionális – válasszon vagy csatlakoztasson kártyaolvasót."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Opcionális – helyezze be az orvosi praxis hitelesítő kártyáját (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN megadása",
      "description": "Biztonsági okokból a QR-kód nem tartalmazza a SOLTOKEN-t. Másolja ki az inSuite „Sol-Aktivierung” (FrontDesk+) oldalán, és illessze be ide.",
      "submit": "Tovább",
      "rescan": "Kód újbóli beolvasása"
    }
  }
}
